export default __webpack_public_path__ + "static/media/support.54f4c23a.svg";